import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './index.css'; // footer styles

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">Naveen J.</Link>
          <p className="footer-tagline">
            Full-stack &amp; AI developer · Python educator · Open to jobs, internships &amp; freelance work.
          </p>
          <p className="footer-availability">
            <span className="footer-status-dot" />
            Available for hire
          </p>
        </div>
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/certificates">Certificates</Link>
          <Link to="/contactme">Hire Me</Link>
        </div>
        <div className="footer-social">
          <a href="https://github.com/Jnaveen1" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="https://www.linkedin.com/in/venkata-naveen-kumar-janapati/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="mailto:naveenjanapati65@gmail.com" aria-label="Email">
            <FaEnvelope />
          </a>
        </div>
      </div>
      <p className="footer-copy">&copy; {year} Venkata Naveen Kumar Janapati. B.Tech 2026 · VVIT Guntur.</p>
    </footer>
  );
};

export default Footer;
